module.exports = __webpack_public_path__ + "static/people_img31-cbec02475690d0cfe6f3f1b08797de37.png";